import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CommonLayout from "../../../../_utils/CommonLayout";
import ICONS from "../../../../../assets/Icons";
import BankDetails from "../../../../_utils/AccountCreationComponents/BankDetails";
import ConfidentialCard from "../../../../_utils/TransactionCommonComponents/ConfidentialCard";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import ActiveInactiveAssociatePopup from "../../../../_utils/ActiveInactiveAssociatePopup";
import TEXT from "../../../../../utils/globalText";

const FieldFieldBankDetails = ({
  setBankLookupNext,
  bankLookupNext,
  nextButtonEnabled,
  BenEnableNextButton,
  payload,
  setPayload,
  activeStep,
  ownerAccIfscError,
  manualVirtualAccount,
  setManualVirtualAccount,
  ownerAccIfscData,
  hideBankBlock,
  isButtonDisabled,
  setBankUserInfo,
  bankVerificationStatus,
  setBankVerificationStatus,
  isIFSCValid,
  isBankError,
  virtualAccount,
  setVirtualAccount,
  previousId,
  setPreviousBankNo,
  type,
}) => {
  const {
    verifyBankAccountLoading,
    bankLookupData,
    bankLookupLoading,
    ifscDetailsLoading,
    bankLookupError,
    verifyBankAccountData,
  } = useSelector((state) => state.sharedResources);

  const ifscData = ownerAccIfscData?.ifsc_details?.[0];

  useEffect(() => {
    bankLookupData?.beneficiary_accounts?.find((val) => {
      if (val?.approval_status === "approved") {
        if (val?.id === previousId) {
          setPreviousBankNo(val?.bank_acc_no);
        }
      }
    });
  }, [bankLookupData]);

  const [isBankLinkedAccount, setIsBankLinkedAccount] = useState(false);
  const [isCreateAccount, setIsCreateAccount] = useState(false);

  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Field force account",
  );
  const [openAssociatePopup, setOpenAssociatePopup] = useState(false);

  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    if (
      !bankLookupLoading &&
      !ifscDetailsLoading &&
      !verifyBankAccountLoading &&
      !bankLookupData?.beneficiary_accounts?.length &&
      !isBankError &&
      isIFSCValid &&
      bankLookupError === true &&
      verifyBankAccountData
    ) {
      setShowDetails(true);
    } else {
      setShowDetails(false);
    }
  }, [
    bankLookupLoading,
    verifyBankAccountLoading,
    bankLookupData,
    bankLookupError,
    isBankError,
    verifyBankAccountData,
    isIFSCValid,
    ifscDetailsLoading,
  ]);

  useEffect(() => {
    const foundAccount = bankLookupData?.beneficiary_accounts?.find((val) => {
      if (
        payload?.panNumber === val?.pan_no &&
        payload?.bank_account === val?.bank_acc_no &&
        payload?.ifsc_code === val?.ifsc_code
      ) {
        setIsBankLinkedAccount(true);
        setIsCreateAccount(true);

        return true;
      }
      return false;
    });

    if (foundAccount) {
      setCurrentAssociate(
        foundAccount?.type_of_account === "field_force"
          ? "Field force account"
          : foundAccount?.type_of_account === "reimbursement"
            ? "Reimbursement account"
            : foundAccount?.type_of_account === "tds"
              ? "Tax account"
              : "Beneficiary account",
      );
      setAccActiveInactiveState(
        foundAccount?.approval_status === "rejected" ||
          foundAccount?.approval_status === "blocked" ||
          foundAccount?.approval_status === "archived"
          ? "inactive"
          : "active",
      );
    }

    if (!foundAccount) {
      if (bankLookupData?.beneficiary_accounts?.length > 0) {
        const accounts = bankLookupData?.beneficiary_accounts || [];

        const foundAccount =
          accounts?.find((val) => val?.type_of_account === "field_force") ||
          accounts?.find((val) => val?.type_of_account === "reimbursement") ||
          accounts?.find((val) => val?.type_of_account === "tds") ||
          accounts?.find((val) => val?.type_of_account === "beneficiary");

        setCurrentAssociate(
          foundAccount?.type_of_account === "field_force"
            ? "Field force account"
            : foundAccount?.type_of_account === "reimbursement"
              ? "Reimbursement account"
              : foundAccount?.type_of_account === "tds"
                ? "Tax account"
                : "Beneficiary account",
        );
        setAccActiveInactiveState(
          foundAccount?.approval_status === "rejected" ||
            foundAccount?.approval_status === "blocked" ||
            foundAccount?.approval_status === "archived"
            ? "inactive"
            : "active",
        );
      }
      setIsBankLinkedAccount(false);
      setIsCreateAccount(false);
    }
  }, [bankLookupData, payload, openAssociatePopup]);

  return (
    <>
      <div className="px-padding-md lg:px-padding-base pb-padding-md py-padding-md Qsmd:py-padding-base">
        <CommonLayout>
          <div className="w-width-full">
            {hideBankBlock && !isBankError && !virtualAccount ? (
              <div className="flex items-center justify-center p-padding-md mt-margin-md mb-margin-md bg-emphasis rounded-border-radius-md opacity-base-opacity">
                <img
                  src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                  alt="info"
                  className="h-icon-md mr-margin-sm "
                />
                <p className="text-font-md font-normal text-text-primary opacity-base-opacity">
                  To unblock this account, please contact customer support
                </p>
              </div>
            ) : isBankLinkedAccount && isIFSCValid ? (
              <div className="flex items-center w-width-full lg:h-top-md p-padding-md mb-margin-md bg-emphasis rounded-border-radius-md opacity-base-opacity">
                <img
                  src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                  alt="info"
                  className="h-icon-md mr-margin-sm"
                />
                <p className="w-width-full  lg:w-auto pt-padding-xs text-left text-font-sm font-normal tracking-normal text-text-primary opacity-base-opacity">
                  The bank account is already linked to the PAN provided. To
                  proceed, update either the bank details or the PAN associated
                  with the profile.
                </p>
              </div>
            ) : null}
            {virtualAccount && isIFSCValid ? (
              <>
                <div className="flex flex-row gap-x-gap-sm bg-emphasis p-padding-md mb-margin-md rounded-border-radius-md">
                  <img
                    src={ICONS.VIRTUAL_ACCOUNT}
                    alt="Virtual Account"
                    className="w-icon-md h-icon-md"
                  />
                  <div className="flex flex-col gap-y-gap-sm">
                    <p className="text-font-sm text-text-primary font-semibold">
                      Virtual Account Detected
                    </p>
                    <ul className="flex flex-col gap-y-gap-sm list-disc list-inside ml-margin-xs">
                      <li className="text-font-xs text-text-primary font-normal">
                        Account could not be verified as it is virtual account.
                      </li>
                      <li className="text-font-xs text-text-primary font-normal">
                        Please self verify and proceed with caution.
                      </li>
                    </ul>
                  </div>
                </div>
              </>
            ) : null}
            <div
              className={`h-fit w-full lg:max-w-[var(--create-box-width)] ${
                type === "switch_account"
                  ? "opacity-light-opacity"
                  : "opacity-base-opacity"
              }`}
            >
              <BankDetails
                payload={payload}
                setPayload={setPayload}
                BenEnableNextButton={BenEnableNextButton}
                activeStep={activeStep}
                setVirtualAccount={setVirtualAccount}
                setBankUserInfo={setBankUserInfo}
                bankLookupNext={bankLookupNext}
                setBankLookupNext={setBankLookupNext}
                bankVerificationStatus={bankVerificationStatus}
                setBankVerificationStatus={setBankVerificationStatus}
                virtualAccount={virtualAccount}
                isIFSCValid={isIFSCValid}
                setShowDetails={setShowDetails}
                manualVirtualAccount={manualVirtualAccount}
                setManualVirtualAccount={setManualVirtualAccount}
                ifscData={ifscData}
                ownerAccIfscError={ownerAccIfscError}
                ownerAccIfscLoading={ifscDetailsLoading}
                type={type}
              />
            </div>
          </div>
          <div
            className={`w-width-full flex flex-col lg:max-w-[var(--create-box-width)] ${
              type === "switch_account"
                ? "opacity-light-opacity pointer-events-none"
                : "opacity-base-opacity"
            }`}
          >
            {isBankError === true &&
              !verifyBankAccountLoading &&
              ownerAccIfscError === false &&
              !ifscDetailsLoading && (
                <ConfidentialCard
                  icon={ICONS.VIRTUAL_ACCOUNT}
                  title={TEXT?.MARK_VIRTUAL_ACCOUNT}
                  note={TEXT?.VIRTUAL_ACCOUNT_NOTE}
                  toggleState={manualVirtualAccount}
                  onToggle={() => {
                    const nextState = !manualVirtualAccount;
                    setManualVirtualAccount(nextState);
                    setBankVerificationStatus(!bankVerificationStatus);
                    setPayload({
                      ...payload,
                      virtual: nextState ? true : false,
                    });
                  }}
                />
              )}

            {bankLookupLoading === false &&
              ifscDetailsLoading === false &&
              verifyBankAccountLoading === false &&
              !(isBankLinkedAccount && isIFSCValid) && (
                <div style={{ overflow: "hidden" }}>
                  <div
                    className={
                      !(isBankLinkedAccount && isIFSCValid)
                        ? "animate-slideInFromRight"
                        : ""
                    }
                  >
                    {" "}
                    <ConfirmBtnAccCreation
                      type="bank"
                      status={
                        bankLookupData?.beneficiary_accounts?.length >
                        GlobalConfiguration?.lengthCheckZero
                      }
                      isIFSCValid={isIFSCValid}
                      isBankError={isBankError}
                      lookupNext={
                        type === "switch_account" ? true : bankLookupNext
                      }
                      isButtonDisabled={
                        type === "switch_account"
                          ? false
                          : isBankLinkedAccount && isIFSCValid
                      }
                      nextButtonEnabled={
                        type === "switch_account" ? false : nextButtonEnabled
                      }
                      handleClick={() => {
                        if (type === "switch_account") return;
                        if (!isButtonDisabled && !isCreateAccount) {
                          setIsCreateAccount(false);
                          setBankLookupNext(true);

                          BenEnableNextButton(false);
                        } else {
                          return;
                        }
                      }}
                    />
                  </div>{" "}
                </div>
              )}

            <div
              style={{
                display:
                  (bankLookupData?.status &&
                    bankLookupData?.beneficiary_accounts?.length >
                      GlobalConfiguration?.lengthCheckZero) ||
                  bankLookupLoading ||
                  verifyBankAccountLoading ||
                  virtualAccount
                    ? "block"
                    : isIFSCValid && isBankError
                      ? "none"
                      : "block",
              }}
            >
              <ActiveInactiveAssociatePopup
                // flow={
                //   isBankError === true
                //     ? "hideAssociate"
                //     : verifyBankAccountData === null ||
                //         bankLookupLoading ||
                //         verifyBankAccountLoading
                //       ? "defaultBank"
                //       : isBankLinkedAccount && isIFSCValid
                //         ? "Existing"
                //         : showDetails
                //           ? "notFoundBank"
                //           : "Bank"
                // }
                flow={
                  isBankError === true
                    ? "hideAssociate"
                    : isBankLinkedAccount && isIFSCValid
                      ? "Existing"
                      : showDetails
                        ? "notFoundBank"
                        : !showDetails &&
                            bankLookupData?.beneficiary_accounts?.length
                          ? "Bank"
                          : "defaultBank"
                }
                dropDownNo={GlobalConfiguration?.lengthCheckTwo}
                ifsc={payload?.ifsc_code}
                bank={payload?.bank_account}
                pan={payload?.panNumber}
                accActiveInactiveState={accActiveInactiveState}
                setAccActiveInactiveState={setAccActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
                ifscLength={payload?.ifsc_code?.length}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </>
  );
};
export default FieldFieldBankDetails;
